export default {
  empty: "empty",
  readyToChange: "ready_to_change",
  readyToPack: "ready_to_pack",
  invoicing: "invoicing",
  preparable: "preparable",
  inPreparation: "in_preparation",
  sent: "sent",
  received: "received",
  postReturned: "post_returned",
  returned: "returned",
  purchased: "purchased",
  lost: "lost",
};
